/**
 * Core Scriptable type definitions that are not defined in @types/scriptable-ios
 */

export type WidgetFamily =
  | 'small'
  | 'medium'
  | 'large'
  | 'extraLarge'
  | 'accessoryCircular'
  | 'accessoryRectangular'
  | 'accessoryInline';
